import { DateTime } from 'luxon';

import { TIME_FORMAT } from 'utils/constants';

export const getFormattedTime = (date, { format = TIME_FORMAT, zone } = {}) =>
  date ? DateTime.fromISO(date, { zone }).toFormat(format) : '';
